import { Group } from "./group";
import { PollingAddress } from "./pollingAddress";

export enum GroupRuleSearchPatternType {
    AttachmentName = 0,
    Subject = 1,
    EmailOrAttachmentContent = 2,
}

export interface GroupRuleSearchPattern {
    searchPatternId?: number;
    isCaseSensitive: boolean;
    isRegex: boolean;
    pattern: string;
    searchPatternType: GroupRuleSearchPatternType;
}

export interface GroupRuleRequest {
    name: string;
    emailAccountId: number;
    groupId: number;
    precedence: number;
    mustMatchAllPatterns: boolean;
    fromAddresses: string[];
    searchPatterns: GroupRuleSearchPattern[];
}

export interface GroupRule extends GroupRuleRequest {
    groupRuleId: number;
    emailAccount: PollingAddress;
    group: Group;
}
export interface GroupRulePrecedence {
    groupRuleId: number;
    precedence: number;
}
